/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/camelcase */
/** ============================ */
/*  This file was autogenerated  */
/*  with `npm run codegen`       */
/* ============================= */

import { gql } from "@apollo/client";
import * as ApolloReactCommon from "@apollo/client";
import * as ApolloReactHooks from "@apollo/client";

import * as Types from "../../../../../api/types.generated";
export type UpsertRegistrationBadgeProfileMutationVariables = Types.Exact<{
  userId: Types.Scalars["Float"];
  badgeDisplayName: Types.Scalars["String"];
  interests: Types.Scalars["String"];
}>;

export type UpsertRegistrationBadgeProfileMutation = {
  upsertExtendedProfile: Pick<Types.Claim, "user_id">;
};

export const UpsertRegistrationBadgeProfileDocument = gql`
  mutation UpsertRegistrationBadgeProfile(
    $userId: Float!
    $badgeDisplayName: String!
    $interests: String!
  ) {
    upsertExtendedProfile(
      user_id: $userId
      badge_display_name: $badgeDisplayName
      interests: $interests
    ) {
      user_id
    }
  }
`;

/**
 * __useUpsertRegistrationBadgeProfileMutation__
 *
 * To run a mutation, you first call `useUpsertRegistrationBadgeProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpsertRegistrationBadgeProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [upsertRegistrationBadgeProfileMutation, { data, loading, error }] = useUpsertRegistrationBadgeProfileMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      badgeDisplayName: // value for 'badgeDisplayName'
 *      interests: // value for 'interests'
 *   },
 * });
 */
export function useUpsertRegistrationBadgeProfileMutation(
  baseOptions?: ApolloReactHooks.MutationHookOptions<
    UpsertRegistrationBadgeProfileMutation,
    UpsertRegistrationBadgeProfileMutationVariables
  >
) {
  return ApolloReactHooks.useMutation<
    UpsertRegistrationBadgeProfileMutation,
    UpsertRegistrationBadgeProfileMutationVariables
  >(UpsertRegistrationBadgeProfileDocument, baseOptions);
}
export type UpsertRegistrationBadgeProfileMutationHookResult = ReturnType<
  typeof useUpsertRegistrationBadgeProfileMutation
>;
export type UpsertRegistrationBadgeProfileMutationResult =
  ApolloReactCommon.MutationResult<UpsertRegistrationBadgeProfileMutation>;
export type UpsertRegistrationBadgeProfileMutationOptions =
  ApolloReactCommon.BaseMutationOptions<
    UpsertRegistrationBadgeProfileMutation,
    UpsertRegistrationBadgeProfileMutationVariables
  >;
